import {$qsAll} from '../../../../@shared/ts/dom';
import {type ModalPage, type LoadingMode} from '../../models/IEnvironment';
import {DefaultCart} from '../../reducers/cartReducer';
import {Environment} from '../../reducers/environmentReducer';
import {PaymentConfiguration} from '../../reducers/paymentConfigurationReducer';
import {store} from '../../store';
import {formatCurrencyString} from '../../util/currency';
import {getLocaleText} from '../../util/translation';

export function setupStripeButton() {
	store.subscribe(() => {
		renderStripeButtonDisplay(
			PaymentConfiguration.selectedGateway(),
			Environment.modalUI.page(),
			Environment.modalUI.loadingMode(),
		);

		renderStripeButtonLoading(
			Environment.modalUI.loadingMode(),
		);
	});
}

/**
 * Renders the stripe button display state.
 */
function renderStripeButtonDisplay(gatewayId: string, page: ModalPage, loadingMode: LoadingMode) {
	// Show/hide Stripe button container
	if (gatewayId.startsWith('peachpay_stripe_') && page === 'payment') {
		$qsAll('.stripe-btn-container', $element => {
			$element.classList.remove('hide');
		});
	} else {
		$qsAll('.stripe-btn-container', $element => {
			$element.classList.add('hide');
		});
	}

	// Hide/Show button
	if (loadingMode === 'loading') {
		$qsAll('.stripe-btn', $element => {
			$element.classList.add('hide');
		});
	} else {
		$qsAll('.stripe-btn', $element => {
			$element.classList.remove('hide');
		});
	}
}

/**
 * Renders the stripe button loading state.
 */
function renderStripeButtonLoading(mode: LoadingMode) {
	// Show/hide the external spinner
	if (mode === 'loading') {
		$qsAll('.stripe-spinner-container', $element => {
			$element.classList.remove('hide');
		});
	} else {
		$qsAll('.stripe-spinner-container', $element => {
			$element.classList.add('hide');
		});
	}

	// Show/hide the internal spinner
	if (mode === 'processing') {
		$qsAll('.stripe-btn-spinner', $element => {
			$element.classList.remove('hide');
		});
	} else {
		$qsAll('.stripe-btn-spinner', $element => {
			$element.classList.add('hide');
		});
	}

	// Show/hide processing message
	if (mode === 'processing') {
		$qsAll('.stripe-btn > .button-text', $element => {
			$element.innerHTML = getLocaleText('Processing');
		});
	} else {
		$qsAll('.stripe-btn > .button-text', $element => {
			$element.innerHTML = `${getLocaleText('Pay')} ${formatCurrencyString(DefaultCart.total())}`;
		});
	}

	// Enable/disable the stripe button
	if (mode === 'finished') {
		$qsAll<HTMLInputElement>('.stripe-btn', $element => {
			$element.disabled = false;
		});
	} else {
		$qsAll<HTMLInputElement>('.stripe-btn', $element => {
			$element.disabled = true;
		});
	}
}
